import { TierSort } from './../tierSort/tierSort';
import { Tier } from '../tier/tier';
import { TierRate } from '../../interfaces';

export class MultiTierTax {
    
    private tiers: TierRate[];
    private amount: number;
    tax: number;

    constructor(tiers: TierRate[], amount: number) {
        this.tiers = new TierSort(tiers).tiers;
        this.amount = amount || 0;

        this.tax = Math.round(this.tiers.reduce((acc, current, index) => acc + Math.max(0, this.tierTax(index)), 0));
    }
    
    tierAmount(index: number): number {
        const tierTo = this.tiers[index].to;
        const previous = index ? this.tiers[index - 1].to || 0 : 0;
        const amount = Math.max(this.amount - previous, 0);

        return tierTo === undefined
            ? amount
            : Math.min(amount, tierTo - previous);
    };
    
    tierTax(index: number): number {
        const amount = this.tierAmount(index);
        return new Tier(this.tiers[index]).tax(amount);
    }
}
